@if (isDisclaimerVisible) {
<!--     
    <div class="row alert ">
        <h5 class="wp-header-text">{{disclaimerText}}</h5>
    </div>
 -->
  <div class="row text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
    <p>{{disclaimerText}}</p>
  </div>

}
